<div class="datatable" [ngClass]="{'datatable--no-filters': !isShowFiltersRow}">
  <div class="datatable__container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <!-- Columna de acciones manual -->
      <ng-container matColumnDef="Acciones" *ngIf="actionsTemplate">
        <th mat-header-cell *matHeaderCellDef class="datatable__container__header-cell">{{ 'DATATABLE.Acciones' | translate }}</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"></ng-container>
        </td>
      </ng-container>

      <!-- Columnas con cada uno de los títulos (encabezados) y datos correspondientes  -->
      <ng-container *ngFor="let col of displayedColumns">
        <ng-container *ngIf="col !== 'Acciones'" [matColumnDef]="col">
          <th mat-header-cell *matHeaderCellDef class="datatable__container__header-cell"
            [matTooltip]="getColumnTooltipText(col) | translate"
            [matTooltipDisabled]="!getColumnTooltip(col)"
            matTooltipClass="label-tooltip">
            {{ 'DATATABLE.'+ col | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element[col] }}</td>
        </ng-container>
      </ng-container>

      <!-- Columnas con cada uno de los filtros  -->
      <ng-container *ngFor="let filter of columnsFiltered; let i = index" [matColumnDef]="getIdByColumn(filter,  i)">
        <th mat-header-cell *matHeaderCellDef>
          <div [ngSwitch]="filter.filterType" class="datatable__container__filter-wrapper">
            <atom-date-range *ngSwitchCase="'Calendar'" (rangeChange)="onChangeDateRange($event, filter.title)" [maxMonthsRange]="maxMonthsRange" #dateRangeRef></atom-date-range>
            <atom-input-select *ngSwitchCase="'Dropdown'"
              [formControl]="selectValues[filter.title]"
              (changed)="onChangeSelect($event, filter.title)"
              [optionsList]="columnOptions[filter.title]">
            </atom-input-select>
            <atom-input-autocomplete *ngSwitchCase="'Autocomplete'"
              [formControl]="autocompleteValues[filter.title]"
              (changed)="onChangeAutocomplete($event, filter.title)"
              [optionsList]="columnOptions[filter.title]"
            />
              <span *ngSwitchDefault></span>
              <atom-button *ngIf="filter.filterType !== 'No filter'" [isPrimaryButton]="false" [displayIcon]="true" [iconType]="'discard'" (click)="onRemoveFilter(filter)"></atom-button>
          </div>
        </th>
      </ng-container>

      <!-- Mostrar filas de la tabla con las columnas definidas -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <!-- Mostrar fila de filtros -->
      <tr mat-header-row *matHeaderRowDef="filterColumns" [ngClass]="{'datatable__container__row--show-no-filters': !isShowFiltersRow}"></tr>

      <!-- Mostrar fila cuando no hay información -->
      <tr class="mat-row" *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length" class="datatable__container__header-cell--no-results">
          {{ 'MESSAGES.No se encontraron datos.' | translate }}
        </td>
      </tr>

      <!-- Mostrar las filas de datos de la tabla -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator *ngIf="showPaginator" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>
